export default __webpack_public_path__ + "static/media/circle.ef78fb4b.svg";